import http from '../../shared/http.js';
import { initFormModalLinks } from '../../shared/formModal.js';
import { initLiveList } from '../../shared/liveList.js';
import {
  confirmAction,
  hideLoading,
  notifyError,
  notifySuccess,
  showLoading
} from '../../shared/notify.js';

// What each row button does, so the handler below stays a lookup rather than a
// chain of ifs.
const ACTIONS = {
  delete: {
    confirm: (titel) => ({
      title: 'Job löschen',
      message: `Möchten Sie ${titel} endgültig löschen? Das kann nicht rückgängig gemacht werden.`,
      okText: 'Löschen'
    }),
    loading: 'Job wird gelöscht …',
    done: 'Job wurde gelöscht.',
    run: (id) => http.delete(`/jobs/${id}`)
  }
};

export function initJobList() {
  // Filtering, searching and paging, all without a reload. The two forms are
  // merged into one query string by the shared module, so searching keeps the
  // filters and filtering keeps the search.
  const live = initLiveList({
    results: 'job-list',
    path: '/jobs',
    forms: ['job-filter', 'job-search']
  });
  if (!live) return;

  // Creating and editing happen in the shared dialog rather than on their own
  // page. The links keep their href, so a middle click still opens the real
  // page - initFormModalLinks only intercepts a plain left click.
  //
  // Anchored on /jobs/… rather than any href ending in /new or /edit: the
  // customer column links to /kunden/…, and a future control there must not be
  // swallowed by this list's dialog.
  //
  // Delegated from document, because the "create" button sits in the page header
  // while the row's edit links arrive with each refreshed fragment.
  initFormModalLinks({
    selector: 'a[href^="/jobs/"][href$="/new"], a[href^="/jobs/"][href$="/edit"]',
    // This list can redraw itself, so a save refetches instead of reloading -
    // the filters, the page and the scroll position all stay put.
    onSaved: () => live.refresh()
  });

  const list = document.getElementById('job-list');

  // One delegated listener for the whole table, so rows cost nothing to add and
  // the rows that arrive with each refreshed fragment are live without rebinding
  // anything.
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-action]');
    if (!button) return;

    const action = ACTIONS[button.dataset.action];
    if (!action) return;

    const { jobId, jobTitel } = button.dataset;

    if (action.confirm && !(await confirmAction(action.confirm(jobTitel)))) return;

    button.disabled = true;
    showLoading(action.loading);

    try {
      await action.run(jobId);
      // Refetch rather than reload: the list redraws without the deleted row
      // while the filters, the search and the scroll position all stay put. The
      // toast is shown directly, since there is no navigation to carry a flash
      // key through the URL.
      await live.refresh();
      hideLoading();
      notifySuccess(action.done);
    } catch (err) {
      hideLoading();
      button.disabled = false;
      notifyError(
        err.response?.data?.message || 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.'
      );
    }
  });
}
